import { useAuth } from "../context/AuthContext";
import DirectorDashboard from "./dashboards/DirectorDashboard";
import AssistantManagerDashboard from "./dashboards/AssistantManagerDashboard";
import SalesOfficerDashboard from "./dashboards/SalesOfficerDashboard";

export default function DashboardPage() {
  const { user } = useAuth();
  const role = user?.role;

  if (role === "director" || role === "admin") return <DirectorDashboard />;
  if (role === "assistant_manager" || role === "admin_manager") return <AssistantManagerDashboard />;
  return <SalesOfficerDashboard />;
}
